import { Component } from '@angular/core';

@Component({
  selector: 'xp-user',
  templateUrl: './user.component.html',
  styleUrl: './user.component.scss'
})
export class UserComponent {

}
